import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import D197 from "./courses/1-5/D197";
import D284 from "./courses/1-5/D284";
import D333 from "./courses/1-5/D333";
import D370 from "./courses/1-5/D370";
import D372 from "./courses/1-5/D372";
import D386 from "./courses/1-5/D386";
import D387 from "./courses/1-5/D387";
import D480 from "./courses/1-5/D480";
import Landing from "./Landing";
import D308 from "./courses/15-20/D308";
import D282 from "./courses/15-20/D282";
import D280 from "./courses/15-20/D280";
import D424 from "./courses/10-15/D424";
import D288 from "./courses/10-15/D288";
import D287 from "./courses/10-15/D287";
import D278 from "./courses/10-15/D278";
import D276 from "./courses/10-15/D276";
import D479 from "./courses/5-10/D479";
import D427 from "./courses/5-10/D427";
import D426 from "./courses/5-10/D426";
import D385 from "./courses/5-10/D385";
import D336 from "./courses/5-10/D336";
import D326 from "./courses/5-10/D326";
import D315 from "./courses/5-10/D315";
import D279 from "./courses/5-10/D279";
import D277 from "./courses/5-10/D277";
import C949 from "./courses/5-10/C949";
import WGUStory from "./WGUStory";
import { analytics } from "./firebase";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logEvent } from "firebase/analytics";

function AnalyticsTracker(){
  const location = useLocation();

  useEffect(()=>{
    if(analytics){
      logEvent(analytics, "page_view", {page_path: location.pathname});
    }
  }, [location]);
  return null;
}

function App() {
  return (
    <div className="App">
      <Router>
        <AnalyticsTracker/>
        <Routes>
          <Route path="" element={<WGUStory />} />
          <Route path="/courses" element={<Landing />} />
          <Route path="/d372" element={<D372 />} />
          <Route path="/d197" element={<D197 />} />
          <Route path="/d370" element={<D370 />} />
          <Route path="/d333" element={<D333 />} />
          <Route path="/d386" element={<D386 />} />
          <Route path="/d284" element={<D284 />} />
          <Route path="/d480" element={<D480 />} />
          <Route path="/d387" element={<D387 />} />
          <Route path="/c949" element={<C949 />} />
          <Route path="/d277" element={<D277 />} />
          <Route path="/d279" element={<D279 />} />
          <Route path="/d315" element={<D315 />} />
          <Route path="/d326" element={<D326 />} />
          <Route path="/d336" element={<D336 />} />
          <Route path="/d385" element={<D385 />} />
          <Route path="/d426" element={<D426 />} />
          <Route path="/d427" element={<D427 />} />
          <Route path="/d479" element={<D479 />} />
          <Route path="/d276" element={<D276 />} />
          <Route path="/d278" element={<D278 />} />
          <Route path="/d287" element={<D287 />} />
          <Route path="/d288" element={<D288 />} />
          <Route path="/d424" element={<D424 />} />
          <Route path="/d280" element={<D280 />} />
          <Route path="/d282" element={<D282 />} />
          <Route path="/d308" element={<D308 />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
